// test1496
(1496 && 0);
